// extracted by mini-css-extract-plugin
export var link = "_vl-0";